/**
 * Resolve a raw surcharge code (or carrier alias) to the mapped display
 * description from `system.surcharge_codes`.
 */

export function normalizeSurchargeCode(raw: string): string {
  return raw.trim().toUpperCase();
}

/**
 * Return the mapped description when one exists and is more than the code
 * itself. Aliases resolve through their standard code.
 */
export function resolveSurchargeDescription(
  raw: string,
  codeMap: Record<string, string>,
  aliasToCode: Record<string, string> = {},
): string | null {
  const key = normalizeSurchargeCode(raw);
  if (!key) return null;

  const direct = codeMap[key];
  if (isUsefulDescription(direct, key)) return direct;

  const mapped = aliasToCode[key];
  if (!mapped) return null;
  const mappedKey = normalizeSurchargeCode(mapped);
  const viaAlias = codeMap[mappedKey];
  return isUsefulDescription(viaAlias, key) ? viaAlias : null;
}

function isUsefulDescription(
  description: string | undefined,
  code: string,
): description is string {
  if (!description) return false;
  const trimmed = description.trim();
  return trimmed.length > 0 && trimmed.toUpperCase() !== code;
}
